
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface DisplaySettingsSectionProps {
  formData: {
    is_featured: boolean;
    display_order: number;
  };
  onInputChange: (field: string, value: boolean | number) => void;
}

export default function DisplaySettingsSection({ formData, onInputChange }: DisplaySettingsSectionProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          id="is_featured"
          checked={formData.is_featured}
          onChange={(e) => onInputChange('is_featured', e.target.checked)}
        />
        <Label htmlFor="is_featured">Featured Expert</Label>
      </div>
      <div>
        <Label htmlFor="display_order">Display Order</Label>
        <Input
          id="display_order"
          type="number"
          value={formData.display_order}
          onChange={(e) => onInputChange('display_order', parseInt(e.target.value) || 0)}
        />
      </div>
    </div>
  );
}
